<template>
    <GChart class="simomicsLineChart" ref="chart" type="LineChart" :data="chartData" :options="chartOptions"
        :style="{'height' : height + 'px'}" style="min-height:200px" />
</template>

<script>
    import { GChart } from 'vue-google-charts'
    import { LineChartData } from '../../../ts/charts/lineChartData'

    export default {
        components: {
            GChart
        },

        props: {
            lineChartData: {
                type: LineChartData
            },
            height: {
                default: 300
            },
            showZero: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                chartData: null,
                chartOptions: this.generateOptions(),
            }
        },
        mounted() {
            this.update()
        },
        watch: {
            lineChartData() {
                this.update()
            }
        },
        methods: {
            update() {
                this.$emit("loading")

                this.$nextTick(() => {
                    this.chartOptions = this.generateOptions()
                    this.chartData = [
                        this.linesFormat(),
                        ...this.addLines()
                    ]

                    this.$nextTick(() => {
                        this.$emit("loaded")
                    })
                })
            },
            linesFormat() {
                let format = [
                    'x-axis',
                ]

                for (const i in this.lineChartData.lines) {
                    format.push('line-' + i)
                    format.push({
                        'type': 'string',
                        'role': 'tooltip',
                        'p': {
                            'html': true
                        }
                    })
                }
                return format

            },
            addLines() {
                let data = []
                for (let i = 0; i < this.lineChartData.steps; i++) {//TODO: can do sample here.
                    let slice = [
                        i
                    ]
                    for (let j in this.lineChartData.lines) {
                        const line = this.lineChartData.lines[j]
                        const point = line.getPoint([i])

                        const useNegOneIfHidingZero = ((!this.showZero) && (point === 0)) ? -1 : point

                        slice.push(useNegOneIfHidingZero) //TODO: getPoint() but not getLine()?

                        slice.push(
                            j === "0" ?
                                this.generateTooltip(point, line.getColor()) :
                                this.generateLimitTooltip(point, line.getColor())
                        )
                    }
                    data.push(slice)
                }
                return data
            },
            generateTooltip(val, color) {
                return `
				<div style="padding: 10px; font-size:8pt; border: 3px solid` + color + `">
					<span style="white-space:nowrap; font-weight: bold;">
						Concentration
					</span></br>
					<span style="white-space:nowrap">` +
                    val +
                    ` ng/L</span>
				</div>
				`
            },
            generateLimitTooltip(val, color) {
                return `
				<div style="padding: 10px; font-size:8pt; border: 3px solid`+ color + `">
					<span style="white-space:nowrap; font-weight: bold;">
						Predicted No-Effect Concentration
					</span></br>
					<span style="white-space:nowrap">` +
                    val +
                    ` ng/L</span>
				</div>
				`
            },
            generateOptions() {
                let options = {
                    'legend': {
                        'position': 'none'
                    },
                    'chartArea': {
                        'width': "70%",
                        'height': "70%",
                    },
                    'tooltip': {
                        'isHtml': true
                    },
                    'vAxis': {
                        "scaleType": 'log',
                        "format": 'short',
                        "baselineColor": 'transparent',
                    },
                    'hAxis': {
                        "textPosition": 'none',
                        "ticks": [],
                        "baselineColor": 'transparent',
                    },
                }

                const colors = this.lineChartData.getColors()
                if (colors) {
                    options['colors'] = colors
                }

                return options
            },
        },
    }

</script>

<style>
    /* Vueitfy dialog index is 201. Tooltip by default is 10000. Which isn't sensible. */
    .simomicsLineChart .google-visualization-tooltip {
        z-index: 180 !important
    }
</style>